import { useState } from "react";
import { CircularProgress } from "@mui/material";

import CustomButton from "../CustomButton";

import { delay } from "../../utils";
import "./style.css";

function CustomActionButton({ isPrimary = true, action, disabled, children, size, type = 1 /*type-1 = with confirmation and orange main color, type-2 = without confirmation and dark main color*/ }) {
    const [status, setStatus] = useState("main");

    const mainAction = async () => {
        if (status != "loading") {
            setStatus("loading");
            const isSuccess = await action();
            if (isSuccess) {
                if (type == 1) {
                    setStatus("success");
                } else {
                    setStatus("main");
                }
            } else {
                setStatus("main");
            }
        }
    };

    return (
        <div id="custom-action-button">
            {status === "main" && (
                <CustomButton
                    isPrimary={isPrimary}
                    size={size}
                    className={`type-${type}}`}
                    disabled={disabled}
                    type="submit"
                    onClick={() => {
                        setStatus("loading");
                        if (type == 1) {
                            delay(() => {
                                setStatus("confirm");
                            }, 300);
                        } else if (type == 2) {
                            mainAction();
                        }
                    }}
                >
                    {children}
                </CustomButton>
            )}
            {status === "confirm" && (
                <CustomButton isPrimary={isPrimary} size={size} className={`confirm-action type-${type}}`} onClick={mainAction}>
                    Confirm
                </CustomButton>
            )}
            {status === "loading" && (
                <CustomButton isPrimary={isPrimary} size={size} onClick={() => { }} className={`type-${type}}`}>
                    <CircularProgress sx={{ color: "#fff" }} />
                </CustomButton>
            )}
            {status === "success" && <CustomButton isPrimary={isPrimary} size={size} onClick={() => setStatus("main")}>Success!</CustomButton>}
        </div>
    );
}

export default CustomActionButton;
